var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-supplier-select", attrs: { id: "select" } },
    [
      _c(
        "yxt-select",
        {
          ref: "select",
          class: { hideOption: !_vm.hideOption },
          style: { width: _vm.width },
          attrs: {
            placeholder: _vm.placeholder,
            "popper-append-to-body": false,
            clearable: _vm.clearable,
            size: _vm.size,
          },
          on: { clear: _vm.clearTreeSelect, focus: _vm.changeHideOption },
          model: {
            value: _vm.selectOpition.checkWord,
            callback: function ($$v) {
              _vm.$set(_vm.selectOpition, "checkWord", $$v)
            },
            expression: "selectOpition.checkWord",
          },
        },
        [
          _c(
            "yxt-option",
            {
              staticClass: "setstyle",
              staticStyle: {
                overflow: "auto",
                height: "100%",
                "background-color": "#fff",
              },
              attrs: { value: _vm.selectTree, disabled: "" },
            },
            [
              _c("yxt-input", {
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  placeholder: _vm.$t("pc_biz_o2o_lbl_select_supplier_name"),
                  searchable: "",
                },
                on: { search: _vm.searchCatalog },
                model: {
                  value: _vm.filterSupplierTree,
                  callback: function ($$v) {
                    _vm.filterSupplierTree = $$v
                  },
                  expression: "filterSupplierTree",
                },
              }),
              _c("yxt-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.supplierTreeData,
                  props: _vm.defaultProps,
                  "check-strictly": "",
                  "node-key": _vm.filterKey,
                  "expand-on-click-node": false,
                  "filter-node-method": _vm.filterNode,
                },
                on: {
                  "node-click": function (data, node, item) {
                    return _vm.ClickTreeNode(data, node, item)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }